// Призыв пустого «Избранного» над рекомендациями (HQ-1467, ответ владельца 3895 «3 — а»): сервер шлёт empty_prompt
// только при пустой вкладке и непустых recommendations. Компактно: картинка меньше, заголовок, текст, кнопка action.label.
// Кнопка — только для поддержанного действия: open_catalog → выбор команд (PICK_TEAMS_ROUTE). Своих событий аналитики нет.
import { useNavigate } from 'react-router-dom';
import type { EmptyPrompt } from '../../api/favoritesTypes';
import emptyArt from '../../assets/states/empty.png';
import { PICK_TEAMS_ROUTE } from '../pickTeams/pickTeamsModel';
import styles from './FavEmptyPrompt.module.css';

/** Куда ведёт действие призыва; незнакомое действие — кнопки нет. */
export function promptRoute(kind: string | undefined): string | null {
  return kind === 'open_catalog' ? PICK_TEAMS_ROUTE : null;
}

export function FavEmptyPrompt({ prompt }: { prompt: EmptyPrompt }) {
  const navigate = useNavigate();
  const route = promptRoute(prompt.action?.kind);
  return (
    <div className={styles.prompt} data-empty-prompt={prompt.code}>
      <img className={styles.art} src={emptyArt} alt="" width={72} height={72} />
      {prompt.title && <div className={styles.title}>{prompt.title}</div>}
      {prompt.text && <div className={styles.text}>{prompt.text}</div>}
      {route && prompt.action && (
        <button type="button" className={styles.button} onClick={() => navigate(route)}>{prompt.action.label}</button>
      )}
    </div>
  );
}
